import { render, staticRenderFns } from "./datetime-valueFormat-editor.vue?vue&type=template&id=22092a9b&scoped=true&"
import script from "./datetime-valueFormat-editor.vue?vue&type=script&lang=js&"
export * from "./datetime-valueFormat-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22092a9b",
  null
  
)

export default component.exports